import classnames from 'classnames';
import type { FunctionComponent } from 'react';
import type React from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { Link } from '@/domains/core/routing/components/Link';
import { Chip } from '@/domains/core/tamagoshi/Chip/Chip';

import styles from './ChipLink.module.scss';

export interface ClickTracking {
  position?: number;
  label: string;
  url: string;
  id: number;
}

interface Props {
  label: string;
  href: string;
  id: string;
  className?: string;
  position?: number;
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    data: ClickTracking,
  ) => void;
  dataTestid?: string;
  theme?: 'outline' | 'default';
  colorTheme?: 'blue' | 'light';
  shallow?: boolean;
}

export const ChipLink: FunctionComponent<Props> = ({
  id,
  className,
  href,
  label,
  onClick,
  position,
  dataTestid,
  theme,
  colorTheme,
  shallow,
}) => {
  const rootClassnames = classnames(styles.root, className);

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (onClick) {
      onClick(event, { url: href, label, position, id: parseInt(id, 10) });
    }
  };

  return (
    <Link
      href={href}
      title={label}
      className={rootClassnames}
      onClick={handleClick}
      data-testid={dataTestid}
      {...(shallow !== undefined ? { shallow } : null)}
    >
      <Chip
        className={styles.chip}
        id={id}
        theme={theme}
        tag="span"
        selected={colorTheme === 'blue'}
      >
        <Text
          tag="span"
          type="body2"
          weight="semiBold"
          className={styles.label}
          variant="none"
        >
          {label}
        </Text>
      </Chip>
    </Link>
  );
};

ChipLink.displayName = 'ChipLink';
